module.exports = __webpack_public_path__ + "img/pålestikk2.3b9dcc1b.jpg";